import { createSelector } from 'reselect'
import API from '../../../utils/http/api'
import accountUtils from '../../../utils/account/accountUtils'

// Action Types
const REQUEST = 'steppingblocks/studentSignups/REQUEST'
const FAILURE = 'steppingblocks/studentSignups/FAILURE'
const SUCCESS = 'steppingblocks/studentSignups/SUCCESS'
const SET_SEARCH_FILTER = 'steppingblocks/studentSignups/SET_SEARCH_FILTER'
const SET_ACTIVE_INDEX = 'steppingblocks/studentSignups/SET_ACTIVE_INDEX'

// Reducer
const initialState = {
  requestStarted: false,
  requestEnded: false,
  error: null,
  results: [],
  searchFilter: '',
  activeIndex: 0,
}

export default (_state = initialState, action) => {
  const { type, payload } = action
  switch(type) {
    case REQUEST:
      return {
        ..._state,
        requestStarted: true,
        requestEnded: false,
        error: null,
      }
    case SUCCESS:
      return {
        ..._state,
        requestEnded: true,
        results: payload.results,
      }
    case FAILURE:
      return {
        ..._state,
        requestEnded: true,
        error: payload.error,
      }
    case SET_SEARCH_FILTER:
      return {
        ..._state,
        searchFilter: payload.data,
      }
    case SET_ACTIVE_INDEX:
      return {
        ..._state,
        activeIndex: payload.data,
      }
    default:
      return _state
  }
}

// Actions
export const setSearchFilter = data => ({ type: SET_SEARCH_FILTER, payload: { data } })
export const setActiveIndex = data => ({ type: SET_ACTIVE_INDEX, payload: { data } })

// Action Performers
export const performRetrieveStudentSignups = () => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const { results } = await API.get('/users/subordinate_students')
    dispatch({
      type: SUCCESS,
      payload: {
        results,
      }
    })
    return results
  } catch (error) {
    dispatch({
      type: FAILURE,
      payload: { error: error.message },
    })
  }
}

// Selectors
const getStudentSignups = state => state.studentSignups
const getSearchFilter = createSelector(getStudentSignups, _ => _.searchFilter)

export const getActiveIndex = createSelector(getStudentSignups, _ => _.activeIndex)

export const getSignups = createSelector(getStudentSignups, _ => _.results.map(item => ({
  ...item,
  fullName: accountUtils.getFullName(item),
})))

export const getFilteredSignups = createSelector(
  [getSignups, getSearchFilter],
  (signups, searchFilter) => signups.filter(item => item.fullName.toLowerCase().indexOf(searchFilter.toLowerCase()) !== -1)
)



// WEBPACK FOOTER //
// ./src/routes/authenticated/ParentDashboard/studentSignupsDuck.js